// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"Loader_loader_container__3x-5C","full_screen":"Loader_full_screen__34yfo","loaderWrapper":"Loader_loaderWrapper__28PAr"};